'use strict';

var React = require('react');
var SpriteIconWeb = require('@swiggy-private/dls-web-food-icons/dist/SpriteIconWeb');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var styled = require('styled-components');
var jsUtils = require('@swiggy-private/js-utils');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const TextContent = styled__default.default(Text.Text)(({ theme }) => ({
    textTransform: "uppercase",
    marginTop: theme.spacing.xxSmall,
    marginLeft: theme.spacing.xxSmall,
}));
const IconContainer = styled__default.default.div(() => ({
    width: "14px",
    height: "14px",
}));

function OfferTag({ offers }) {
    if (jsUtils.isEmpty(offers)) {
        return null;
    }
    const offer = offers === null || offers === void 0 ? void 0 : offers[0];
    if (jsUtils.isEmpty(offer)) {
        return null;
    }
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(IconContainer, null,
            " ",
            React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: "offersFilled16", fillColor: "positive", strokeColor: "positive" })),
        React__default.default.createElement(TextContent, { color: "text_Med_Emphasis", variant: "V2.overline.neutral.bold" },
            React__default.default.createElement("span", null, offer === null || offer === void 0 ? void 0 :
                offer.title,
                " "),
            (offer === null || offer === void 0 ? void 0 : offer.subTitle) && React__default.default.createElement("span", null, offer === null || offer === void 0 ? void 0 : offer.subTitle))));
}
var OfferTagV4 = React.memo(OfferTag);

exports.OfferTagV4 = OfferTagV4;
//# sourceMappingURL=OffertagV4-CLotnX1F.js.map
